<template>
  <a-modal
  :afterClose="handleAfterClose"

    class="detail-modal"
    :title="null"
    v-model="modalVisible"
    :footer="null"
    width="90%"
    centered
  >
 
    <a-spin tip="Yüklənir..." :spinning="pageLoading" v-if="problem">
      <!--  <citizen-list style="max-height: 500px;" :citizenslist="problem.appeals"></citizen-list> -->
      <div>
        <div
          style="
            font-size: 18px;
            text-align: center;
            border-bottom: 1px solid lightgray;
          "
        >
          {{ problem.title }}
        </div>
        <div style="font-size: 18px">
          <span style="font-weight: bold !important"> Şikayət nömrəsi: </span
          >{{ problem.number.pad(6) }}
        </div>
      </div>
      <div
        style="
          margin-bottom: 5px;
          font-size: 18px;
          display: flex;
          flex-direction: column;
        "
      >
        <div v-if="problem.executive" style="font-weight: 600">
          <span style="font-weight: bold !important"
            >Yerli icra hakimiyyəti:</span
          >
          {{ problem.executive.name }}
        </div>

        <div>
          <span v-if="problem.executive.region">
            <span style="font-weight: bold !important">Ünvan:</span>
            {{ problem.executive.region.name }}
          </span>
          <span v-if="problem.street">{{ `, ${problem.street.name}` }}</span>
          <span v-if="problem.address"> {{ `, ${problem.address}` }} </span>
        </div>
      </div>

      <div
        v-if="getCategoriesOfProblem.length > 0"
        style="display: flex; align-items: center; margin: 0px 0px 20px 0px"
      >
        <p
          style="
            margin-right: 15px;
            font-size: 19px;
            margin-bottom: 0;
            font-weight: bold !important;
          "
        >
         Müraciətin təsnifatı:
        </p>

        <div style="display: flex;flex-wrap: wrap;">
          <a-tag
            v-for="category in getCategoriesOfProblem"
            :key="category.uuid"
            color="#108ee9"
            style="display: flex; align-items: center; font-size: 15px; margin:5px ; white-space: break-spaces;"
          >
            {{ category.name }}
            {{ category.parent ? `(${category.parent.name})` : "" }}
          </a-tag>
        </div>
      </div>

      <g-map
        style="width: 100%"
        :latitude="problem.latitude"
        :longitude="problem.longitude"
        :height="400"
      ></g-map>
      <p v-if="problem.officeDetails.length == 0">
        Şikayətə digər təşkilat əlavə edilməyib
      </p>

      <!---General operations if no officedetail-->
      <operations-table
        v-if="problem.officeDetails.length == 0"
        :dataSource="problem.operations"
      />
      
    <!-- 4cooment -->

    <h2 style="   text-align: center;
    margin: 21px auto;
    width: 270px;
    border-bottom: 1px solid lightgray;">Rəy üçün göndərilənlər</h2>
  <a-table
    :columns="columns"
    :rowKey="(record) => record.id"
    :dataSource="problem.assignments4Comments"
    :pagination="pagination"
     :locale="mylocale"
    class="video-list"
    size="middle"
    >
      <template slot="user" slot-scope="record">
      {{ record.addedUser.firstName +  " "+ record.addedUser.lastName + " " + record.addedUser.fatherName}}
    </template>
       <template slot="fromComment" slot-scope="record">
      {{ record.fromStructure.name }}
    </template>
       <template slot="toComment" slot-scope="record">
      {{ record.toStructure.name }}
    </template>
   <template slot="comment" slot-scope="record">
      {{ record.comment }}
    </template>



  </a-table>

      <a-tabs :defaultActiveKey="0" v-model="tabKey" @change="handleTabChange">
        <a-tab-pane
          v-for="(detailOffice, index) in problem.officeDetails"
          :key="'office' + index"
          :tab="getTabHeader(detailOffice)"
        >
          <!--:style="{backgroundColor:problem.priority.color}"-->
          <a-row>
            <a-col span="24">
              <div style="float: right">
                <a-button
                  type="primary"
                  icon="check"
                  v-if="detailOffice.canBeAssessed"
                  @click="addAssestment(problem, detailOffice)"
                  >Qiymətləndir</a-button
                >
              </div>
            </a-col>
          </a-row>

          <!--Citizens assests for each office-->

          <!-- <citizen-list :compStyle="{maxHeight:'150px'}" :citizenslist="problem.appeals" :type="citizenListType"
           :rdOffice="selectedRdOffice"/>
           -->

          <!--Executor table here-->
          <executor-table
            :dataSource="detailOffice.executeDetails"
          ></executor-table>

          <!---Operations table here-->
          <operations-table
            :dataSource="detailOffice.operations"
          ></operations-table>




        </a-tab-pane>
      </a-tabs>

      <citizen-details v-if="problem" :dataSource="applicants" />




      <a-row
        type="flex"
        v-if="problem.appeals"
        style="margin-top: 20px; margin-bottom: 20px"
      >
        <a-col :span="selectedAppeal ? 8 : 12">
          <citizen-list
        
            :compStyle="{ maxHeight: '500px' }"
            :citizenslist="problem.appeals"
            :type="citizenListType"
            @assested="handleAsssested"
            :selectable="true"
            @changeSelected="handleAppealSelChange"
          />
          <a-pagination
            style="float: right"
            size="small"
            :total="problem.appeals.length"
          />
        </a-col>
        <a-col :span="16" v-if="problem && selectedAppeal">
          <conditional-media
            :filesList="selectedAppeal.files"
          ></conditional-media>
        </a-col>
      </a-row>
    </a-spin>

    <!--media dialog-->
    <a-modal
      title="Müraciətəfaylları"
      v-model="mediadialogVisibility"
      :footer="null"
      :width="980"
      centered
    >
      <conditional-media :filesList="files"></conditional-media>
    </a-modal>
  </a-modal>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
import ExecutorTable from "@/components/partials/ExecutorTable/index";
import OperationsTable from "@/components/partials/OperationsTable/index";
import Assestment from "@/components/partials/Assestment/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import CitizenList from "@/components/partials/CitizenList/index";
import mixin from "@/mixins/index";
import Map from "@/components/partials/Map/index";
import CitizenDetails from "@/components/partials/CitizenDetails/index";

export default {
  name: "DetailModal",
  mixins: [mixin],
  props: { visible: Boolean, problemOb: Object },
  components: {
    "executor-table": ExecutorTable,
    "operations-table": OperationsTable,
    asestments: Assestment,
    "conditional-media": ConditionalMedia,
    "citizen-list": CitizenList,
    "g-map": Map,
    "citizen-details": CitizenDetails,
  },
  data() {
    return {
      modalVisible: false,
      problem: null,
      mediadialogVisibility: false,
      files: [],
      pageLoading: false,
      tabKey: "office0",
      citizenListType: null,
      selectedRdOffice: null,
      selectedAppeal: null,
      applicants: [],
      mylocale: { emptyText: "Məlumat yoxdur" },
         pagination: {
        pageSize: 10,
        current: 1,
        
        size: "small",
       
      },
         columns : [
 
        {
          title: "İstifadəçilər",
          width: "20%",
          scopedSlots: { customRender: "user" },
          align: "center",
        },
        {
          title: "Rəy bildirilən",
          scopedSlots: { customRender: "fromComment" },
          width: "15%",
          align: "center",
        },
           {
          title: "Rəy bildirən",
          scopedSlots: { customRender: "toComment" },
          width: "15%",
          align: "center",
        },
             {
          title: "Rəy",
          scopedSlots: { customRender: "comment" },
          width: "15%",
          align: "center",
        },
  
   
    
      ],
    };
  },
  computed: {
    getCategoriesOfProblem: function () {
  /*     const categories = this.problem ? this.problem.categories : [];
      return categories; */

      if (this.problem.officeDetails.map(item=>item?.category).filter(item=>item!=null).length>0) {
        return  this.problem.officeDetails.map(item=>item?.category).filter(item=>item!=null);
      } else if( this.problem.categories){
        return this.problem?.categories||[]
      }else{
        return []
      }
    },
  },
  methods: {
    handleAfterClose(){
      this.problem=null;
      this.applicants=null
      this.selectedAppeal=null;
    },
    getDetailData() {
      if (!this.problemOb) return;
      this.pageLoading = true;
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "problems/" +
          this.problemOb.id,
        params: {
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
          all: true,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.problem = response.data.data;
            this.selectedRdOffice = this.problem.officeDetails[0];
            this.problem.officeDetails.forEach((officeDetail) => {
              officeDetail.operations = officeDetail.operations
                .concat(this.problem.operations)
                .sort((a, b) => {
                  return b.id - a.id;
                });
            });

            this.getProblemApplicants(this.problem.id);
          } else this.$message.error(response.data.error.message);
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.$message.error("Xəta baş verdi");
        });
    },
    getHeader(detailOffice) {
      return detailOffice.office
        ? detailOffice.office.name + " (" + detailOffice.parentOffice.name + ")"
        : detailOffice.parentOffice.name;
    },
    showMediaDialog(detail) {
      this.files = detail.files;
      if (!this.files || this.files.length === 0) {
        this.$message.warning("Media fayl yoxdur");
        return;
      }
      this.mediadialogVisibility = true;
    },
    handleTabChange(key) {
      if (this.type === "ASSESTMENT") {
        this.selectedRdOffice = this.problem.officeDetails[
          key.replace("office", "")
        ];
        this.getCitizenAppeals({
          problemId: this.problem.id,
          detailed: true,
          officeDetailId: this.selectedRdOffice.id,
        });
      }
    },
    handleAppealSelChange(appeal) {
      this.selectedAppeal = appeal;
    },
    handleAsssested() {
      if (this.type === "ASSESTMENT") {
        this.getCitizenAppeals({
          problemId: this.problem.id,
          detailed: true,
          officeDetailId: this.selectedRdOffice.id,
        });
      }
    },
  },
  created() {
    this.modalVisible = this.visible;
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
      if (!oldValue && newValue && this.problemOb) {
        this.getDetailData();
      }
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.problem = null;
        this.mediadialogVisibility = false;
        this.$emit("afterClose");
      }
    },
    // problem: {
    //   immediate: true,
    //   handler: function(newVal) {
    //     console.log(newVal);
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
